import { validateIsRecord } from "./utils";

export function getPlayerStateIncrement(
  data: Record<string, unknown>,
): number | null {
  if (!validateIsRecord(data.meta)) {
    return null;
  }
  const value = data.meta.stateIncrement;
  return typeof value === "number" && Number.isSafeInteger(value) && value >= 0
    ? value
    : null;
}
